import {
  InputBaseProps,
  TextField,
  TextFieldProps,
} from '@forgeglobal/design-framework';
import { MaskitoOptions } from '@maskito/core';
import { useMaskito } from '@maskito/react';
import { FieldRenderProps } from 'react-final-form';
import { useStyles } from './style';

interface MaskedTextFieldProps<T> extends TextFieldProps<T> {
  options: MaskitoOptions;
  'data-test-id'?: string;
}

const MaskedTextField = (
  props: MaskedTextFieldProps<any>,
): React.ReactElement<FieldRenderProps<any, HTMLInputElement>> => {
  const { onChange, ...input } = props.input;
  const classes = useStyles();
  const maskedInputRef = useMaskito({ options: props.options });

  const inputProps: Partial<InputBaseProps> = {
    classes: { input: !props.label ? classes.input : undefined },
    ref: maskedInputRef,
    placeholder: props.placeholder,
    onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
      const target = e.target;

      Promise.resolve().then(() => {
        onChange(target.value);
      });
    },
  };

  if (props.startAdornment) {
    inputProps.startAdornment = props.startAdornment;
  }

  if (props.endAdornment) {
    inputProps.endAdornment = props.endAdornment;
  }

  return (
    <TextField
      label={props.label}
      required={props.required}
      disabled={props.disabled}
      sx={props.sx}
      data-test-id={props['data-test-id']}
      /* @ts-ignore, onChange handler is not required when using maskedInputRef */
      input={{
        ...input,
        onChange,
      }}
      meta={props.meta}
      InputProps={inputProps}
      data-private={props['data-private']}
    />
  );
};

export default MaskedTextField;
